import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { ModalButtonWithForm } from 'components/common';
import { Checkbox, FormGroup } from 'components/common/form';

const AchievementTemplateSettings = () => {
  const { dispatch } = useDispatch();

  const {
    messages,
    pageState: { achievement }
  } = useReduxState();

  const handleSubmit = async ({ isTemplateShareable }) => {
    const response = await api.put(`/admin/achievements/${achievement.id}`, {
      isTemplateShareable
    });
    if (!response.data || !response.data.success) throw new Error('error');

    const achievementsResponse = await api.get(
      `/admin/achievements?id=${achievement.id}`
    );

    dispatch.updatePageState({
      achievement: achievementsResponse.data.achievements[0]
    });
    dispatch.addNotice({
      text: messages.settingsSavedSuccessfully,
      type: 'success'
    });
  };

  return (
    <ModalButtonWithForm
      buttonCategory="lighter"
      buttonIcon="cog"
      buttonProps={{ iconStyle: { fontSize: '1rem', marginRight: 3 } }}
      buttonSize="small"
      buttonStyle={{
        borderRadius: 30,
        padding: '3px 10px 4px 8px',
        margin: '-2px 0',
        position: 'relative',
        top: -1
      }}
      buttonText={messages.commonSettings}
      formAllowEmptyStrings={true}
      initialValues={{ isTemplateShareable: achievement.isTemplateShareable }}
      modalActionCategory="success"
      modalActionText={messages.commonSaveChanges}
      modalTitle={messages.commonSettings}
      modalWidth="medium"
      onSubmit={handleSubmit}
    >
      {() => (
        <FormGroup label={messages.achievementTemplate}>
          <Checkbox
            id="isTemplateShareable"
            field="isTemplateShareable"
            label={messages.achievementTemplateShareable}
            labelHelpText={messages.achievementTemplateShareableHelpText}
          />
        </FormGroup>
      )}
    </ModalButtonWithForm>
  );
};

export default AchievementTemplateSettings;
